// 评论相关接口
import md5 from 'js-md5';
import {useUserInfo} from '@/hooks/useUserInfo';
import logger, {dataLogger} from '@/utils/logger';
import {COMMENT_BASE_URL, SUCCESS_CODE} from './constants';
import useRequest, {processAfterRequest} from '.';


const PATH_PREFIX = process.env.NODE_ENV !== 'mock' ? '' : '/comments';

const beforeRequest = (data: any) => {
  const timeStamp = new Date().getTime();
  const {sid} = useUserInfo();
  return {
    ...data,
    headers: {
      ...data.headers,
      'sid': sid || '', // sid 有就传
      'system-id': 2, // 2-资讯
      'x-time': timeStamp, // 时间戳
      'x-sign': md5(`${timeStamp}.bc214e1d638a4bd9ad8fdd61fe00c5ff`), // md5(x-time+'.'+token), token 是写死的
      // 'traffic-env': 'test-baihe', // 环境参数, 现在 测试环境 已经不需要加了
    }
  };
};

// 评论列表, 注意评论的 pager 和 code 在一个层级
export const useCommentList = (
  pager: ReqPager,
  params: { informationId: number },
  nativeKey?: string,
  useNative?: boolean,
  type?: 'immediate' | 'await' | 'manual',
) =>
  useRequest<{
    list: {commentDetail: CommentDetail}[];
    pager: Pager;
  }>({
    baseURL: COMMENT_BASE_URL,
    url: `${PATH_PREFIX}/comment/momentCommentQueryNew`,
    method: 'post',
    beforeRequest,
    data: {
      momentNumber: params?.informationId || '',
      orderBy: 'TIME',
      pager: {
        pageNum: pager.current,
        pageSize: 25,
      }
    },
    type,
  });

// 发表评论, informationId 资讯id
export const useCommentPublish = (content: string, informationId: number) =>
  useRequest<{
    commentDetail: CommentDetail;
  }>({
    baseURL: COMMENT_BASE_URL,
    url: `${PATH_PREFIX}/comment/create`,
    method: 'post',
    beforeRequest,
    type: 'manual',
    data: {
      content,
      momentNumber: informationId
    },
    afterRequest(data: any) {
      if (data?.code === SUCCESS_CODE) {
        if (data?.errorTypeCode === 2) { // 关闭评论区返回状态码为0 errorTypeCode为2
          logger('后端返回错误信息:', '#d85542', data.msg);
          return Promise.reject(data);
        }
        dataLogger(data);
        return data.data;
      }
      logger('后端返回错误信息:', '#d85542', `${data?.code}-${data?.message || data?.msg}`);
      return Promise.reject(data);
    }
  });

// 删除评论, commentNumber 评论id
export const useCommentDelete = (commentNumber: string, successCallback: () => void) =>
  useRequest<{
    code: number;
    message: string;
  }>({
    baseURL: COMMENT_BASE_URL,
    url: `${PATH_PREFIX}/comment/delete`,
    method: 'post',
    beforeRequest,
    afterRequest: processAfterRequest({
      successCallback,
      errorInfo: '删除评论失败',
    }),
    data: {
      commentNumber,
    },
  });
